import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ModalHandler from 'components/shared/modal/modal-handler'
import ChangePasswordModal from 'components/shared/modals/change-password'
import authActions from 'actions/auth/actions'
import placesActions from 'actions/places/actions'
import pick from 'lodash/pick'
import ProfileForm from './form'

const Profile = ({
  user,
  company,
  phone,
  place,
  avatar,
  updateProfile,
  fetchPlaceOptions,
  places,
  processing,
}) => {
  useEffect(() => {
    fetchPlaceOptions({ published: true })
  }, [])

  return (
    <>
      <ProfileForm
        onUpdate={values => updateProfile(values)}
        form="merchant-profile-form"
        initialValues={{ ...user, company: company !== 'null' ? company : '', phone, place, avatar }}
        placesOptions={places}
        processing={processing}
      />
      <ModalHandler
        title={`Change password`}
        className="text-sm text-primary-orange cursor-pointer my-5"
      >
        {({ toggle }) => <ChangePasswordModal onClose={toggle} />}
      </ModalHandler>
    </>
  )
}

Profile.propTypes = {
  user: PropTypes.object.isRequired,
  company: PropTypes.string,
  phone: PropTypes.string,
  place: PropTypes.string,
  avatar: PropTypes.string,
  places: PropTypes.array,
  updateProfile: PropTypes.func.isRequired,
  fetchPlaceOptions: PropTypes.func.isRequired,
  processing: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ auth, places }) => ({
  user: pick(auth.user, ['first_name', 'last_name', 'email', 'id']),
  phone: auth.user.profile ? auth.user.profile.phone : '',
  place: auth.user.profile && auth.user.profile.place ? auth.user.profile.place.slug : '',
  company: auth.user.company ? auth.user.company.name : '',
  avatar: auth.user.profile ? auth.user.profile.avatar : '',
  places: places.options,
  processing: auth.processing,
})

const mapDispatchToProps = {
  updateProfile: authActions.updateProfile,
  fetchPlaceOptions: placesActions.fetchPlaceOptions,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile)
